import { Button, Card, Col, Input, Row, Typography } from "antd";
import { StyleSheet } from "../../StyleSheet";
import InfoCardComponent from "../../components/InfoCardComponent";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { Key, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { AppDispatch } from "../../stores/store";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";

const { Text } = Typography;

interface SelectedOpt {
    value: Key;
    label: string;
}

type SendSMSProps = {
    selectDate: SelectedOpt;
    statusChange: boolean;
    statesAcc?: SelectedOpt;
    date: string;
    dateProccess: string;
    sendSmsFnt: Function;
}

const SendSMS = (props: SendSMSProps) => {
    const { selectDate, statusChange, statesAcc, date, sendSmsFnt } = props;
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [nombre, setNombre] = useState<string>("");
    const [mobilePhone, setMobilePhone] = useState("");
    const [mobilePhoneConfirm, setMobilePhoneConfirm] = useState("");
    const [errorsEmptyFields, setErrorsEmptyFields] = useState<any>({
        phone: '',
        phoneConfirm: ''
    });

    const handleChangePhone = (value: string) => {
        setMobilePhone(value);
        if (value) {
            errorsEmptyFields.phone = "";
        }
        if (value.length < 10) {
            errorsEmptyFields.phone = "El número telefónico debe contener 10 dígitos.";
        }
    }

    const handleChangePhoneConfirm = (value: string) => {
        setMobilePhoneConfirm(value);
        if (!_.isEqual(value, mobilePhone)) {
            errorsEmptyFields.phoneConfirm = "Los números no coinciden";
        } else {
            errorsEmptyFields.phoneConfirm = ""
        }
    }

    const handleSave = async () => {
        if (idCliente) {
            let error = '';
            let validPhone = false;
            let validPhoneConfirm = false;
            let validAllPhones = false;

            let errorsFields: any = {
                phone: '',
                phoneConfirm: '',
            };

            if (_.isEmpty(mobilePhone)) {
                let message = "El número de teléfono móvil está vacío.\n"
                error += message;
                errorsFields.phone = message;
            }
            if (mobilePhone.length < 10) {
                let message = "El número de teléfono móvil debe contener 10 dígitos.\n"
                error += message;
                errorsFields.phoneConfirm = message;
            } else {
                validPhone = true;
            }
            if (_.isEmpty(mobilePhoneConfirm)) {
                let message = "La confirmación del teléfono móvil está vacío.\n"
                error += message;
                errorsFields.phoneConfirm = message;
            }
            if (mobilePhoneConfirm.length < 10) {
                let message = "La confirmación del teléfono móvil debe contener 10 dígitos.\n"
                error += message;
                errorsFields.phoneConfirm = message;
            } else {
                validPhoneConfirm = true;
            }
            if (_.isEqual(mobilePhone, mobilePhoneConfirm)) {
                validAllPhones = true;
            } else {
                let message = "Los números no coinciden.\n"
                error += message;
                errorsFields.phoneConfirm = message;
            }

            setErrorsEmptyFields(errorsFields);

            if (validPhone && validPhoneConfirm && validAllPhones) {
                let objSMS = {
                    proceso: selectDate.value.toString(),
                    celular: mobilePhone,
                }
                sendSmsFnt(objSMS)
            } else {
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: "ERROR",
                    title: "¡Estimado Usuario!",
                    message: error,
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
            }
        }
    };

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal +
                generalData.selectedContract.suscriptor
            );
            setNombre(
                generalData.selectedContract.nombre +
                " " +
                generalData.selectedContract.apellidoPaterno +
                " " +
                generalData.selectedContract.apellidoMaterno
            );
        }
    }, [generalData.selectedContract]);
    
    return (
        <>
            <div style={{ marginTop: 10 }}>
                <InfoCardComponent
                    title="¡Atención!"
                    description="Para enviar su estado de cuenta por SMS, digite y confirme su número celular y de click en 'Enviar'" />
            </div>
            <Row gutter={[12, 12]} style={styles.rowPrincipal}>
                <Col xs={24} xl={12}>
                    <Card
                        bodyStyle={{ justifyContent: "center" }}
                        style={{ ...styles.cardRoot }}
                    >
                        <Row style={{ display: "flex", justifyContent: "center" }}>
                            <div
                                style={{
                                    ...styles.divRoot,
                                    backgroundColor: "#0055c2",
                                }}
                            >
                                <Col style={styles.colView}>
                                    <Text style={styles.textPrincipal}>
                                        {nombre}
                                    </Text>
                                    <Text style={styles.textRegular}>
                                        Suscriptor: {idCliente}
                                    </Text>
                                    <Text style={styles.textRegular}>
                                        {generalData.selectedContract?.paquete}
                                    </Text>
                                </Col>
                            </div>
                            <div style={styles.footerCard}>
                                <Text
                                    style={{
                                        ...styles.textDaysLimit,
                                        color: "#000000",
                                    }}
                                >
                                    Tu fecha de corte es el día&nbsp;
                                    <Text
                                        style={{
                                            ...styles.textDateLimit,
                                            color: "#000000",
                                        }}
                                    >
                                        {date}
                                    </Text>
                                </Text>
                            </div>
                        </Row>
                    </Card>
                    {
                        statusChange && selectDate?.value === statesAcc?.value ?
                            <Card
                                style={{ ...styles.cardRoot }}
                            >
                                <Row>
                                    <Col span={18}>
                                        <Text style={styles.textStatus}>
                                            Tienes un saldo <Text style={{ ...styles.textStatus, fontWeight: 600 }}>Pendiente</Text>
                                        </Text>
                                    </Col>
                                    <Col span={6} style={styles.buttonPay}>
                                        <Button
                                            style={{
                                                ...styles.buttonFinal,
                                                backgroundColor: "#167cff",
                                            }}
                                            type="primary"
                                            onClick={() => {
                                                navigate('/payments');
                                            }}
                                        >
                                            Pagar
                                        </Button>
                                    </Col>
                                </Row>
                            </Card>
                            : null
                    }
                </Col>
                <Col xs={24} xl={12}>
                    <Card style={{ ...styles.cardRoot }}>
                        <Row justify="center" gutter={[18, 18]}>
                            <Text style={styles.textBoldConfirm}>
                                ¿Desea enviar por SMS el estado de cuenta
                                de su contrato <Text>{idCliente}</Text>?
                            </Text>
                            <Text style={styles.text}>
                                Digite y confirme su número celular, enseguida
                                de click en <Text style={{ fontWeight: 600 }}>"Enviar"</Text>
                            </Text>
                        </Row>
                        <Row justify={"center"} style={{ marginTop: 15 }} gutter={[12, 12]}>
                            <Col span={20}>
                                <Text style={styles.inputTitle}>Número celular</Text>
                                <Input
                                    value={mobilePhone}
                                    style={styles.inputText}
                                    onChange={(e) => handleChangePhone(e.target.value.replace(/[^0-9]/g, ''))}
                                    maxLength={10}
                                    status={errorsEmptyFields.phone ? errorsEmptyFields.phone : null}
                                />
                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.phone ? errorsEmptyFields.phone : null}</Text>}
                            </Col>
                            <Col span={20}>
                                <Text style={styles.inputTitle}>Confirme número celular</Text>
                                <Input
                                    value={mobilePhoneConfirm}
                                    style={styles.inputText}
                                    onChange={(e) => handleChangePhoneConfirm(e.target.value.replace(/[^0-9]/g, ''))}
                                    maxLength={10}
                                    status={errorsEmptyFields.phoneConfirm ? errorsEmptyFields.phoneConfirm : null}
                                />
                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.phoneConfirm ? errorsEmptyFields.phoneConfirm : null}</Text>}
                            </Col>
                            <Col style={styles.rowButton} span={20}>
                                <Button
                                    style={{
                                        ...styles.buttonFinal,
                                        backgroundColor: "#0055c2",
                                    }}
                                    type="primary"
                                    onClick={handleSave}
                                >
                                    Enviar
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

const styles = StyleSheet.create({
    rowPrincipal: {
        marginTop: 30,
        display: "flex",
    },
    cardRoot: {
        backgroundColor: "white",
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20,
    },
    divRoot: {
        width: "100%",
        borderRadius: 18,
        display: "flex",
        textAlign: "center",
        padding: 15
    },
    colView: {
        display: 'flex',
        flexDirection: 'column',
        width: "100%"
    },
    textPrincipal: {
        color: "white",
        fontSize: 18,
        fontWeight: 600,
    },
    textRegular: {
        color: "white",
        fontSize: 15,
    },
    textBold: {
        color: "white",
        fontSize: 15,
        fontWeight: 600
    },
    text: {
        color: "black",
        fontSize: 15,
        marginLeft: 20
    },
    textBoldConfirm: {
        color: "black",
        fontWeight: 600,
        fontSize: 15,
        marginLeft: 20
    },
    textDaysLimit: {
        color: "#000000",
        textAlign: "center",
        fontSize: 13,
    },
    textDateLimit: {
        color: "#000000",
        textAlign: "center",
        fontSize: 13,
        fontWeight: 600,
    },
    footerCard: {
        display: "flex",
        width: "90%",
        padding: 5,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "0px 0px 20px 20px",
        backgroundColor: "#d9d9d9",
    },
    textStatus: {
        color: "#ff0000",
        textAlign: "center",
        fontSize: 18,
    },
    rowButton: {
        marginTop: 15,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    buttonFinal: {
        backgroundColor: "#0055c2",
        borderRadius: 15,
        color: "white",
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
    },
    emptyFieldError: {
        fontSize: 11
    },
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    inputText: {
        marginTop: 15,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    buttonPay: {
        justifyContent: 'flex-end',
        display: 'flex',
        alignItems: 'center'
    }
});

export default SendSMS;
